"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APISkinGoalsResponseSchema = exports.APISkinGoalsRequestSchema = exports.MAX_SKIN_GOALS = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
const scan_schedule_1 = require("./scan_schedule");
const user_metric_1 = require("./user_metric");
// Constants for skin goals
exports.MAX_SKIN_GOALS = 3;
exports.APISkinGoalsRequestSchema = zod_1.z.object({
    skinGoals: zod_1.z
        .array(zod_1.z.number())
        .min(1, 'Please select at least one goal')
        .max(exports.MAX_SKIN_GOALS, `Please select no more than ${exports.MAX_SKIN_GOALS} goals`),
    selectedMetrics: zod_1.z
        .array(zod_1.z.number())
        .min(1, 'Please select at least one metric')
        .max(user_metric_1.MAX_FAVORITE_METRICS, `Please select no more than ${user_metric_1.MAX_FAVORITE_METRICS} metrics`),
    scanSchedule: scan_schedule_1.APIScanScheduleRequestSchema,
    effortLevel: zod_1.z.enum(enums_1.effortLevelEnum),
    budgetLevel: zod_1.z.enum(enums_1.budgetLevelEnum),
});
exports.APISkinGoalsResponseSchema = exports.APISkinGoalsRequestSchema.extend({
    selectedMetrics: zod_1.z.array(user_metric_1.APIGetUserMetricResponseSchema),
    /** Distinct metric tech names the user's selected goals target (via
     *  goals_to_metric_def). Lets clients map goals to concern groups without the
     *  favorited-metrics table. */
    goalMetricTechNames: zod_1.z.array(zod_1.z.enum(enums_1.techNameEnum)),
    minScans: zod_1.z.number().min(1).max(7),
    effortLevel: zod_1.z.enum(enums_1.effortLevelEnum).nullish(),
    budgetLevel: zod_1.z.enum(enums_1.budgetLevelEnum).nullish(),
});
//# sourceMappingURL=skin_goals.js.map